module.exports = __webpack_public_path__ + "static/img/machine3.7dbdd251.png";